const obligationTranslationKeys = {
  0: 'fiscal_obligation_iva',
  IVA: 'fiscal_obligation_iva',
  1: 'fiscal_obligation_islr_advance',
  ISLRAdvance: 'fiscal_obligation_islr_advance',
  2: 'fiscal_obligation_islr_retention',
  ISLRRetention: 'fiscal_obligation_islr_retention',
  3: 'fiscal_obligation_igtf',
  IGTF: 'fiscal_obligation_igtf',
  4: 'fiscal_obligation_annual_islr',
  AnnualISLR: 'fiscal_obligation_annual_islr'
}

const obligationDefaultLabels = {
  fiscal_obligation_iva: 'Impuesto al Valor Agregado (IVA)',
  fiscal_obligation_islr_advance: 'Anticipo de ISLR',
  fiscal_obligation_islr_retention: 'Retención de ISLR',
  fiscal_obligation_igtf: 'Impuesto a las Grandes Transacciones Financieras (IGTF)',
  fiscal_obligation_annual_islr: 'Declaración anual de ISLR',
  fiscal_obligation_unknown: 'Tipo de obligación no disponible'
}

export const getFiscalObligationLabel = (obligationType, t) => {
  const translationKey = obligationTranslationKeys[obligationType]
    || 'fiscal_obligation_unknown'

  return t(translationKey, {
    defaultValue: obligationDefaultLabels[translationKey]
  })
}
